import { SectionedBOM } from '../integration/DynamakerContract'
import { FlatBOM } from '../store/requests/apiTypes'

export const flattenBom = (sectionedBom: SectionedBOM): FlatBOM => {
  const bom: FlatBOM = []

  sectionedBom.forEach((section) => {
    section.articles.forEach((article) => {
      bom.push({
        qty: article.quantity,
        sku: article.erpItemNumber,
        ...('configData' in article && article.configData && {
          configData: article.configData,
        }),
      })
    })
  })

  return bom
}
